import { inject, observer } from "mobx-react";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CircularProgress } from "@material-ui/core";

const styles = theme => ({
  dialogContent: {
    marginBottom: 25
  }
});

class ConfirmationDialog extends React.Component {
  render() {
    const { confirmationDialogStore } = this.props;

    return (
      <Dialog
        open={confirmationDialogStore.isOpen}
        onClose={() => confirmationDialogStore.close()}
      >
        <DialogTitle>{confirmationDialogStore.title}</DialogTitle>
        <DialogContent>{confirmationDialogStore.children}</DialogContent>
        {confirmationDialogStore.executing ? (
          <DialogActions>
            <CircularProgress />
          </DialogActions>
        ) : (
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => confirmationDialogStore.close()}
              color="secondary"
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                confirmationDialogStore.execute();
              }}
              color="default"
            >
              Yes
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default inject("confirmationDialogStore")(
  withStyles(styles)(observer(ConfirmationDialog))
);



// WEBPACK FOOTER //
// ./src/components/ConfirmationDialog.js